/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetNoticeRequest
 */
export interface RequestGetNoticeRequest {
    /**
     * 0=全拠点
     * @type {number}
     * @memberof RequestGetNoticeRequest
     */
    baseId?: number;
    /**
     * 0=全テナント
     * @type {number}
     * @memberof RequestGetNoticeRequest
     */
    tenantId?: number;
    /**
     * 0=全ユーザー
     * @type {number}
     * @memberof RequestGetNoticeRequest
     */
    userId?: number;
    /**
     * nil=指定なし
     * @type {boolean}
     * @memberof RequestGetNoticeRequest
     */
    visible?: boolean;
}

/**
 * Check if a given object implements the RequestGetNoticeRequest interface.
 */
export function instanceOfRequestGetNoticeRequest(value: object): value is RequestGetNoticeRequest {
    return true;
}

export function RequestGetNoticeRequestFromJSON(json: any): RequestGetNoticeRequest {
    return RequestGetNoticeRequestFromJSONTyped(json, false);
}

export function RequestGetNoticeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetNoticeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'visible': json['visible'] == null ? undefined : json['visible'],
    };
}

export function RequestGetNoticeRequestToJSON(json: any): RequestGetNoticeRequest {
    return RequestGetNoticeRequestToJSONTyped(json, false);
}

export function RequestGetNoticeRequestToJSONTyped(value?: RequestGetNoticeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
        'visible': value['visible'],
    };
}

